import React from 'react'
import { makeHeader } from './styled'

export const RawHeader = makeHeader('h3')

function Header(props) {
  return <RawHeader {...props} />
}

export default Header
